import { render, staticRenderFns } from "./orderRefundDetail.vue?vue&type=template&id=292176ce&"
import script from "./orderRefundDetail.vue?vue&type=script&lang=js&"
export * from "./orderRefundDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports